import { useCallback } from "react";
import { useAxios } from "../useAxios";
import { useAnalytics } from "hooks/useAnalytics";
import { ANALYTICS_EVENTS } from "analytics";
import { USER_API } from "config";

export type TrackableExportType =
  | "coverage"
  | "coverage_summary"
  | "tags_report"
  | "script_report"
  | "notes"
  | "stripboard"
  | "budget"
  | "shooting_calendar"
  | "character_summary"
  | "character_breakdown"
  | "character_breakdown_all"
  | "character_descriptions"
  | "day_out_of_days"
  | "roadmap";

interface TrackExportParams {
  projectId: string | number;
  documentId: string | number;
  exportType: TrackableExportType;
  format?: string;
}

export const useTrackExport = () => {
  const axios = useAxios();
  const { trackEvent } = useAnalytics();

  return useCallback(
    ({ projectId, documentId, exportType, format }: TrackExportParams) => {
      if (!projectId || !documentId) return;
      trackEvent(ANALYTICS_EVENTS.EXPORT_STARTED, {
        project_id: String(projectId),
        document_id: String(documentId),
        export_type: exportType,
        ...(format ? { format } : {}),
      });
      void axios
        .post(USER_API.trackExport(`${projectId}`, `${documentId}`), {
          export_type: exportType,
          ...(format ? { format } : {}),
        })
        .then(() => {
          trackEvent(ANALYTICS_EVENTS.EXPORT_COMPLETED, {
            project_id: String(projectId),
            document_id: String(documentId),
            export_type: exportType,
            ...(format ? { format } : {}),
          });
        })
        .catch(() => {
          trackEvent(ANALYTICS_EVENTS.EXPORT_FAILED, {
            project_id: String(projectId),
            document_id: String(documentId),
            export_type: exportType,
            ...(format ? { format } : {}),
          });
        });
    },
    [axios, trackEvent]
  );
};
